"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.ItemsContainer = exports.ButtonContainer = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        width: '100%',
        gap: theme.spacing(4),
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    };
});
const ItemsContainer = exports.ItemsContainer = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(3)
    };
});
const ButtonContainer = exports.ButtonContainer = (0, _mui.styled)('div')(()=>({
        whiteSpace: 'nowrap'
    }));
